import { Observable } from 'rxjs/Observable';
import { IDelegationRequest } from './http-requests';
import { AppEndpoints } from '../app.endpoints';
import { MetaData } from '../../globals/classes/urlBuilder';
import { HttpService } from '../../globals/providers/http.service';
import { AppSettings } from '../app.settings';

export interface IUserIdentificationRequest {
	userId: string;
	firstName: string;
	lastName: string;
	fathersName: string;
	birthDate: Date;
	tin: string;
	mobilePhone: string;
	documentNo: string;
	address: IAddress;
	verificationCode: string;
}

export class UserIdentificationRequest implements IUserIdentificationRequest {
	public userId: string;
	public firstName: string;
	public lastName: string;
	public fathersName: string;
	public birthDate: Date;
	public tin: string;
	public mobilePhone: string;
	public documentNo: string;
	public address: IAddress;
	public verificationCode: string;

	constructor(request?: IUserIdentificationRequest) {
		let newReq: IUserIdentificationRequest = request || {
			address: new Address(),
			birthDate: null,
			documentNo: null,
			fathersName: null,
			firstName: null,
			lastName: null,
			mobilePhone: null,
			tin: null,
			userId: null,
			verificationCode: null,
		};
		this.read(newReq);
	}

	private read(newReq: IUserIdentificationRequest) {
		this.address = new Address(newReq.address);
		this.birthDate = newReq.birthDate;
		this.documentNo = newReq.documentNo;
		this.fathersName = newReq.fathersName;
		this.firstName = newReq.firstName;
		this.lastName = newReq.lastName;
		this.mobilePhone = newReq.mobilePhone;
		this.tin = newReq.tin;
		this.userId = newReq.userId;
		this.verificationCode = newReq.verificationCode;
	}
}

export interface IAddress {
	street: string;
	number: string;
	zipCode: string;
}

export class Address implements IAddress {
	public street: string;
	public number: string;
	public zipCode: string;

	constructor(address?: IAddress) {
		let newAddress: IAddress = address || {
			number: null,
			street: null,
			zipCode: null,
		};
		this.read(newAddress);
	}
	private read(newAddress: IAddress) {
		this.number = newAddress.number;
		this.street = newAddress.street;
		this.zipCode = newAddress.zipCode;
	}
}

export interface IUserIdentificationResponse {
	status: string;
	needsPhoneVerification: boolean;
	reason: string;
}

export class UserIdentificationResponse implements IUserIdentificationResponse {
	public status: string;
	public needsPhoneVerification: boolean;
	public reason: string;

	constructor(resp?: IUserIdentificationResponse) {
		let newResp: IUserIdentificationResponse = resp || {
			needsPhoneVerification: null,
			reason: null,
			status: null,
		};
		this.read(newResp);
	}
	private read(newResp: IUserIdentificationResponse) {
		this.needsPhoneVerification = newResp.needsPhoneVerification;
		this.reason = newResp.reason;
		this.status = newResp.status;
	}
}

export class UnlockAccountAuth {
	/* Delegate Request */
	public static identifyUser(
		request: IUserIdentificationRequest
	): Observable<IUserIdentificationResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<IUserIdentificationResponse>(
				AppEndpoints.identifyUser,
				request
			);
		} else {
			return UnlockAccountAuth.useDelegateRequestUserIdentification(
				AppEndpoints.identifyUser,
				request
			);
		}
	}

	/* Delegate Request */
	public static verifyUserIdentification(
		request: IUserIdentificationRequest
	): Observable<IUserIdentificationResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<IUserIdentificationResponse>(
				AppEndpoints.verifyUserIdentification,
				request
			);
		} else {
			return UnlockAccountAuth.useDelegateRequestUserIdentification(
				AppEndpoints.verifyUserIdentification,
				request
			);
		}
	}

	/* identifyUser */
	private static useDelegateRequestUserIdentification(
		endPointUrl: string,
		request: IUserIdentificationRequest
	): Observable<IUserIdentificationResponse> {
		return HttpService.post<IUserIdentificationResponse>(
			AppEndpoints.delegateRequest,
			UnlockAccountAuth.setDelegationRequest(endPointUrl, request),
			false
		);
	}

	private static setDelegationRequest(
		endPointUrl: string,
		request: IUserIdentificationRequest
	): IDelegationRequest {
		return {
			audiences: 'LoginApi',
			endPointUrl: endPointUrl,
			body: new MetaData().wrap2Request(request),
		};
	}
}
